<template>
  <div :class="classes">
      <pt-page-title title="税务项目管理">
           <el-button slot="before-left" type="primary" @click="created_taxation">新建税务项目</el-button>
      </pt-page-title>
      <pt-taxation-table :tableLabels="tableLabels" ref="table">
          <el-table-column label="操作">
              <template slot-scope="scope">
                <i class="iconfont icon-dingdanchuangjian" @click="editTax(scope.row)"></i>
                <!-- <i class="iconfont icon-shanchu"  @click="deleteTax(scope.row)"></i> -->
            </template>
          </el-table-column>
      </pt-taxation-table>
  </div>
</template>

<script>
// 组件class前缀
import ptTaxationTable from './pt-taxation-table/withData.vue'
import { taxationTableLabel } from './taxation'
const prefixCls = 'pt-taxation-project-manage'

export default {
  name: 'pt-taxation-project-manage',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptTaxationTable
  },
  data () {
    return {
      tableLabels: taxationTableLabel
    }
  },
  methods: {
    getTableData (page) {
      this.$refs.table.getTableData(page)
    },
    editTax (row) {
      this.$router.push('/taxation-project-manage/taxation-project-form/' + row.id + '/true')
    },
    deleteTax (row) {
      this.$confirm('您确定删除该税务项目吗？', '删除税务项目', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('deleteTax', row.id)
      }).catch(_ => {

      })
    },
    created_taxation () {
      this.$router.push('/taxation-project-manage/taxation-project-form/0/false')
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
<style lang="less">
.pt-taxation-project-manage{
    i{
        margin-right: 10px;
    }
}
</style>
